import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { EdwardColors } from 'enums';
import { borderRadiusBox } from 'components/AppTheme';

interface MenuProps {
  admin?: boolean;
}

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    avatarIcon: {
      marginRight: theme.spacing(2),
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.common.white,
    },
    arrowIcon: (props: MenuProps) => ( {
      padding: theme.spacing(2),
      color: props.admin ? theme.palette.common.white :  theme.palette.common.black,
      [theme.breakpoints.down('xs')]: {
        color: theme.palette.common.white,
      }
    }),
    link: {
      display: 'flex',
      textDecoration: 'none',
      color: theme.palette.common.black,
    },
    divider: {
      borderBottom: 'solid #ccc 1px',
      paddingBottom: 0,
      marginBottom: theme.spacing(1),
    },
    accountTitle: {
      border: 'solid #fff 1px',
      borderRadius: borderRadiusBox,
      fontSize: '19px',
      lineHeight: '42px',
      height: '42px',
      padding: theme.spacing(0,2),
      [theme.breakpoints.down('xs')]: {
        fontSize: '16px',
        paddingLeft: theme.spacing(2),
      },
      '& > div': {
        textOverflow: 'ellipsis',
        overflowWrap: 'break-word',
        maxHeight: '100%',
        overflow: 'hidden',
      },
    },

    account: {
      padding: theme.spacing(2),
      overflow: 'hidden',
      '& > div': {
        padding: theme.spacing(0, 0, 0, 2),
        border: `solid #000 1px`,
        [theme.breakpoints.down('xs')]: {
          borderColor: '#fff'
        },
        borderRadius: borderRadiusBox,
      },
      '& .MuiListItemIcon-root': {
        minWidth: theme.spacing(2),
        padding: theme.spacing(1),
        [theme.breakpoints.down('xs')]: {
          padding: theme.spacing(0.5),
        },
      },
      '& span': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      [theme.breakpoints.down('xs')]: {
        width: '100%',
        padding: theme.spacing(1, 2),
        '& .MuiTypography-body1': { fontSize: '0.8rem' },
      },
      '@media (max-width: 400px)': {
        padding: theme.spacing(1),
        '& > div': {
          paddingLeft: theme.spacing(1),
        },
        '& .MuiListItemIcon-root': {
          padding: theme.spacing(1),
          minWidth: theme.spacing(1),
        },
      },
    },
    accountsList: {
      marginTop: theme.spacing(2),
      '& .MuiListItemIcon-root': {
        minWidth: theme.spacing(4),
      },
      '& .MuiMenuItem-root:not(:last-child)': {
        borderBottom: 'solid #ccc 1px',
      },
      [theme.breakpoints.down('xs')]: {
        marginTop: theme.spacing(1),
        '& .MuiMenuItem-root': {
          whiteSpace: 'normal',
        },
        '& .MuiListItemIcon-root': {
          display: 'none',
        },
        '& .MuiPaper-root': {
          marginLeft: theme.spacing(2),
          width: '100%',
          maxWidth: '100%',
        },
      },
    },
    userMenu: {
      '& .MuiListItemIcon-root': {
        minWidth: theme.spacing(6),
      },
    },
    avatar: {
      padding: 0,
      '& .MuiListItemIcon-root': {
        minWidth: theme.spacing(2),
        padding: theme.spacing(2, 0, 2, 0),
        [theme.breakpoints.down('xs')]: {
          padding: theme.spacing('13px', 0),
        }
      },
      [theme.breakpoints.down('xs')]: {
        '&.userMode:not(.signOnly)': { display: 'none'},
        '& .MuiListItem-root': { padding: theme.spacing(0,2,0,1)},
        '& .MuiAvatar-root': { display: 'none' }, //&.detail
      },
    },
    active: {
      '& svg': {
        color: EdwardColors.SECONDARY,
      },
      '& .MuiTypography-body1': {
        fontWeight: 'bold',
        color: EdwardColors.SECONDARY,
      },
    },
  }),
);
